import { getQuestionsResponse } from '../surveyBuilder/sharedQuestions/sagas/createSection';
import {
	CHANGE_SECTION_TRANSLATE_INFO,
	DELETE_TRANSLATION_LANGUAGE,
	SAVE_TRANSLATION_LANGUAGE,
	SET_ALL_TRANSLATED_LANGUAGES,
	SET_DEFAULT_BUTTONS_DATA,
	SET_GOOGLE_LANGUAGES_LIST,
	SET_TRANSLATED_BUTTON_DATA,
	SET_TRANSLATED_BUTTONS_INFO,
	SET_TRANSLATED_DATA,
	SET_TRANSLATED_QUESTION_INFO,
	SurveyMultiLingualDataReducer,
	SurveyMultiLingualDataState,
} from './types';
import { fill, set } from 'shades';

const initialState: SurveyMultiLingualDataState = {
	googleLanguagesList: [],
	savedSurveyLanguages: [],
	currentEditingLanguageCode: '',
	currentEditingLanguageQues: [],
	defaultButtonsList: [],
	currentEditingLanguageButtonsData: [],
};

export const surveyMultiLingualDataReducer: SurveyMultiLingualDataReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_ALL_TRANSLATED_LANGUAGES: {
			const { data } = action.payload;
			return { ...state, savedSurveyLanguages: data };
		}
		case SET_GOOGLE_LANGUAGES_LIST:
			return fill(state)({
				...state,
				googleLanguagesList: action.payload.data,
			});
		case SAVE_TRANSLATION_LANGUAGE: {
			const { languages } = action.payload;
			return fill(state)({
				...state,
				savedSurveyLanguages: [...state.savedSurveyLanguages, ...languages],
			});
		}
		case DELETE_TRANSLATION_LANGUAGE: {
			const { langCode } = action.payload;
			const filteredLanguages = state.savedSurveyLanguages.filter((lang) => lang?.code !== langCode);
			return {
				...state,
				savedSurveyLanguages: filteredLanguages,
			};
		}
		case SET_TRANSLATED_DATA: {
			const {
				data: { languagesList, selectedLanguge, questionnaire },
			} = action.payload;
			const quesData = getQuestionsResponse(questionnaire?.surveys?.[0]?.questions);
			return {
				...state,
				savedSurveyLanguages: questionnaire?.languagesList,
				currentEditingLanguageCode: selectedLanguge,
				currentEditingLanguageQues: quesData,
			};
		}

		case SET_TRANSLATED_QUESTION_INFO: {
			const sectionQuestions =
				Object.values(state['currentEditingLanguageQues'])
					.map((question) => question?.questionnaireId)
					.flat() || [];
			if (sectionQuestions.includes(action.payload.questionId)) {
				const currentQuestion: any = action.payload.state;
				return set(
					'currentEditingLanguageQues',
					currentQuestion?.questionnaireSectionId,
					'currentEditingLanguageQues',
					action.payload.questionId
				)(currentQuestion)(state as any) as any;
			} else {
				return set('currentEditingLanguageQues', action.payload.questionId)(action.payload.state)(state as any) as any;
			}
		}

		case CHANGE_SECTION_TRANSLATE_INFO: {
			const { id, metaData } = action.payload;
			let requiredSection = state.currentEditingLanguageQues[id];
			requiredSection = {
				...requiredSection,
				metaData: {
					...requiredSection.metaData,
					...metaData,
				},
			};
			return {
				...state,
				currentEditingLanguageQues: {
					...state.currentEditingLanguageQues,
					[id]: requiredSection,
				},
			};
		}

		case SET_DEFAULT_BUTTONS_DATA: {
			const { data } = action.payload;
			return {
				...state,
				defaultButtonsList: data,
			};
		}

		case SET_TRANSLATED_BUTTON_DATA: {
			const {
				data: { languages, translations },
			} = action.payload;
			return {
				...state,
				savedSurveyLanguages: languages,
				currentEditingLanguageCode: translations?.[0]?.languageCode,
				currentEditingLanguageButtonsData: translations,
			};
		}

		case SET_TRANSLATED_BUTTONS_INFO: {
			const { id, text } = action.payload;
			const updatedData = state.currentEditingLanguageButtonsData.map((item: any) => {
				if (item?.textId === id) {
					return {
						...item,
						translatedText: text, // update translatedText
					};
				}
				return item;
			});

			return { ...state, currentEditingLanguageButtonsData: updatedData };
		}
		default:
			return state;
	}
};
